import { gql } from "@apollo/client";

export const FIND_ALL_STAKEHOLDER_GROUPS_BY_COMMUNICATION_PLAN = gql`
  query FindAllStakeHolderGroupsByCommunicationPlan($uuid: ID!) {
    findAll: findAllStakeHolderGroupsByCommunicationPlan(uuid: $uuid) {
      contactFirstName
      contactLastName
      email
      name
      phone
      uuid
    }
  }
`;

export const CREATE_STAKEHOLDER_GROUP = gql`
  mutation CreateStakeHolderGroup($data: CreateStakeHolderGroupInput!) {
    createStakeHolderGroup(data: $data) {
      contactFirstName
      contactLastName
      email
      name
      phone
      uuid
    }
  }
`;

export const UPDATE_STAKEHOLDER_GROUP = gql`
  mutation UpdateStakeHolderGroup($data: UpdateStakeHolderGroupInput!) {
    updateStakeHolderGroup(data: $data) {
      contactFirstName
      contactLastName
      email
      name
      phone
      uuid
    }
  }
`;

export const DELETE_STAKEHOLDER_GROUP = gql`
  mutation DeleteStakeHolderGroup($uuid: ID!) {
    deleteStakeHolderGroup(uuid: $uuid) {
      contactFirstName
      contactLastName
      email
      name
      phone
      uuid
    }
  }
`;